// PARAQTA — toast хабарлама + clipboard share helper.
// toast() — #toast элементі арқылы 2.5 сек ішінде көрсетеді.

export function toast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2500);
}

export function copyShareLink(url) {
  navigator.clipboard.writeText(url)
    .then(() => toast('Сілтеме көшірілді!'))
    .catch(() => {
      // Fallback ескі браузерлерге
      const inp = document.createElement('input');
      inp.value = url;
      document.body.appendChild(inp);
      inp.select();
      document.execCommand('copy');
      document.body.removeChild(inp);
      toast('Сілтеме көшірілді!');
    });
}
